<template>
  <div>
    <v-card>
      <v-card-title primary-title>
        <v-btn flat icon color="black" class="backButton" @click="goBack">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <h3 class="headline mb-0 listTitle">{{listData.name}}</h3>
      </v-card-title>
      <v-progress-circular :value="(listData.numOfCheckedItems / this.items.length) * 100" :rotate="-90" color="accent" :buffer-value="100" :size="100" :width="15" style="margin: 0 auto; display: block;">{{listData.numOfCheckedItems}} / {{this.items.length}}</v-progress-circular>
      <br>
    </v-card>
    <br>
    <v-list subheader>
      <v-subheader>Pinned items</v-subheader>
      <v-list-tile v-for="(item, key) in items" :key="key" v-if="item.pinned">
        <v-list-tile-action>
          <v-checkbox v-model="item.checked" @click="checkItem(item)"></v-checkbox>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          <v-list-tile-sub-title v-if="item.lastBought">Last bought: {{item.lastBought | moment("MM/DD/YY")}}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-menu bottom offset-y>
            <v-btn icon ripple slot="activator">
              <v-icon color="grey lighten-1">more_vert</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="pinItemToggle(item)">
                <v-list-tile-title>Unpin</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showEditItem(item)">
                <v-list-tile-title>Edit</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showMoveItem(item)">
                <v-list-tile-title>Move</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="deleteItem(item)">
                <v-list-tile-title>Delete</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
      <v-subheader>All items</v-subheader>
      <v-list-tile v-for="(item, key) in items" :key="key" v-if="!item.pinned && !item.checked">
        <v-list-tile-action>
          <v-checkbox v-model="item.checked" @click="checkItem(item)"></v-checkbox>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          <v-list-tile-sub-title v-if="item.quantity > 1">Quantity: {{ item.quantity }}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-menu bottom offset-y>
            <v-btn icon ripple slot="activator">
              <v-icon color="grey lighten-1">more_vert</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="pinItemToggle(item)">
                <v-list-tile-title>Pin</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showEditItem(item)">
                <v-list-tile-title>Edit</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showMoveItem(item)">
                <v-list-tile-title>Move</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="deleteItem(item)">
                <v-list-tile-title>Delete</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
      <v-subheader>Checked</v-subheader>
      <v-list-tile v-for="(item, key) in items" :key="key" v-if="item.checked && !item.pinned">
        <v-list-tile-action>
          <v-checkbox v-model="item.checked" @click="checkItem(item)"></v-checkbox>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="strikethrough">{{ item.name }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-menu bottom offset-y>
            <v-btn icon ripple slot="activator">
              <v-icon color="grey lighten-1">more_vert</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="pinItemToggle(item)">
                <v-list-tile-title>Pin</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showEditItem(item)">
                <v-list-tile-title>Edit</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showMoveItem(item)">
                <v-list-tile-title>Move</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="deleteItem(item)">
                <v-list-tile-title>Delete</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <br>
    <br>
    <br>

    <v-dialog v-model="dialogModel.newItem" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
      <v-card tile>
        <v-toolbar color="primary">
          <v-btn icon @click.native="dialogModel.newItem = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Item</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn flat @click.native="addItem">Add</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-text-field name="item-name" label="Name" v-model="itemModel.name"></v-text-field>
          <v-text-field name="item-quantity" label="Quantity" type="number" v-model="itemModel.quantity"></v-text-field>
          <v-switch label="Pin item" v-model="itemModel.pinned"></v-switch>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogModel.editItem" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
      <v-card tile>
        <v-toolbar color="primary">
          <v-btn icon @click.native="dialogModel.editItem = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Item</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn flat @click.native="editItem">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-text-field name="item-name" label="Name" v-model="itemModel.name"></v-text-field>
          <v-text-field name="item-quantity" label="Quantity" type="number" v-model="itemModel.quantity"></v-text-field>
          <v-switch label="Pin item" v-model="itemModel.pinned"></v-switch>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogModel.moveItem" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
      <v-card tile>
        <v-toolbar color="primary">
          <v-btn icon @click.native="dialogModel.moveItem = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Move Item</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn flat @click.native="moveItem">Move</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-text-field name="item-name" label="Name" v-model="itemModel.name" disabled></v-text-field>
          <v-radio-group v-model="selectedList">
            <v-radio v-for="(list, key) in lists" :key="key" :label="list.title" :value="list.id"></v-radio>
            <v-radio v-for="(list, key) in sharedLists" :key="key + 100000000" :label="list.title" :value="list.id"></v-radio>
          </v-radio-group>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogModel.loading" persistent max-width="200px">
      <v-card>
        <v-card-title style="font-weight: bold; font-size: 20px;">Loading...</v-card-title>
        <v-card-text>
          <v-progress-circular indeterminate color="accent" style="margin: 0 auto; display: block;" size="64"></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-btn color="accent" dark fixed bottom right fab @click.stop="dialogModel.newItem = true" :class="mobileFabClass">
      <span class="group pa-2">
        <v-icon>add</v-icon>
      </span>
    </v-btn>
    <!-- <v-btn color="accent" dark fixed bottom right fab @click.stop="dialogModel.newItem = true" class="md2-fab" :class="mobileFabClass">
      <span class="group pa-2">
        <v-icon>add</v-icon> Add item
      </span>
    </v-btn> -->
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import { firestore, checkAuth } from '../firestoreConnection';

export default {
  name: 'view-list',
  data() {
    return {
      items: [],
      dialogModel: {
        newItem: false,
        loading: true,
        editItem: false,
        moveItem: false
      },
      itemModel: {
        name: '',
        pinned: false,
        id: '',
        lastBought: '',
        quantity: 1
      },
      lists: [],
      sharedLists: [],
      selectedList: '',
      listData: {
        name: 'List',
        numOfCheckedItems: 0
      }
    };
  },
  computed: {
    mobileFabClass: function() {
      return this.$store.state.isMobile ? 'mobileFab' : '';
    }
  },
  created() {
    checkAuth(this)
      .then(
        function() {
          firestore
            .doc(`lists/${this.$route.params.id}`)
            .get()
            .then(
              function(data) {
                this.listData.name = data.data().title;
              }.bind(this)
            )
            .catch(function(error) {
              console.log(error);
            });

          this.$bind(
            'items',
            firestore.collection(`lists/${this.$route.params.id}/items`).where('visible', '==', true)
          );

          this.$bind('lists', firestore.collection(`lists`).where('owner', '==', this.$store.state.user.uid));

          this.$bind(
            'sharedLists',
            firestore
              .collection(`lists`)
              .where(`sharedWith.${this.$store.state.user.uid}.uid`, '==', this.$store.state.user.uid)
          );

          setTimeout(
            function() {
              if (this.items == '') {
                this.dialogModel.loading = false;
              }
            }.bind(this),
            5000
          );
        }.bind(this)
      )
      .catch(
        function() {
          this.$router.push('/login');
        }.bind(this)
      );
  },
  methods: {
    checkItem: function(item) {
      if (item.checked) {
        item.checked = false;
      } else {
        item.checked = true;
      }

      if (item.checked) {
        firestore.doc(`lists/${this.$route.params.id}/items/${item.id}`).update({
          checked: item.checked,
          lastBought: new Date().getTime()
        });
      } else {
        firestore.doc(`lists/${this.$route.params.id}/items/${item.id}`).update({
          checked: item.checked
        });
      }
    },
    addItem: function() {
      this.dialogModel.loading = true;

      firestore
        .collection(`lists/${this.$route.params.id}/items`)
        .doc()
        .set({
          name: this.itemModel.name,
          pinned: this.itemModel.pinned,
          visible: true,
          quantity: this.itemModel.quantity
        })
        .then(
          function() {
            this.itemModel.name = '';
            this.itemModel.pinned = false;
            this.itemModel.quantity = 1;
            this.dialogModel.newItem = false;
            this.dialogModel.loading = false;
          }.bind(this)
        )
        .catch(function(error) {
          alert('Cannot add item');
          console.log(JSON.stringify(error));
          this.dialogModel.loading = false;
        });
    },
    deleteItem: function(item) {
      let canDelete = confirm(`Delete ${item.name}?`);
      if (canDelete) {
        firestore.doc(`lists/${this.$route.params.id}/items/${item.id}`).delete();
      }
    },
    pinItemToggle: function(item) {
      if (item.pinned) {
        item.pinned = false;
      } else {
        item.pinned = true;
      }

      firestore.doc(`lists/${this.$route.params.id}/items/${item.id}`).update({
        pinned: item.pinned
      });
    },
    showEditItem: function(item) {
      this.itemModel.name = item.name;
      this.itemModel.pinned = item.pinned;
      this.itemModel.id = item.id;
      this.itemModel.quantity = item.quantity | 1;
      this.dialogModel.editItem = true;
    },
    editItem: function() {
      this.dialogModel.loading = true;

      firestore.doc(`lists/${this.$route.params.id}/items/${this.itemModel.id}`).update({
        name: this.itemModel.name,
        pinned: this.itemModel.pinned,
        quantity: this.itemModel.quantity
      });

      this.itemModel.name = '';
      this.itemModel.pinned = false;
      this.itemModel.id = '';
      this.itemModel.quantity = 1;
      this.dialogModel.editItem = false;
      this.dialogModel.loading = false;
    },
    showMoveItem: function(item) {
      this.itemModel.name = item.name;
      this.itemModel.id = item.id;
      this.itemModel.pinned = item.pinned;
      this.itemModel.lastBought = item.lastBought;
      this.dialogModel.moveItem = true;
    },
    moveItem: function(list) {
      console.log('ll: ' + this.selectedList);
      this.dialogModel.loading = true;

      if (this.itemModel.lastBought) {
        firestore
          .collection(`lists/${this.selectedList}/items`)
          .doc()
          .set({
            name: this.itemModel.name,
            pinned: this.itemModel.pinned,
            lastBought: this.itemModel.lastBought,
            visible: true
          });
      } else {
        firestore
          .collection(`lists/${this.selectedList}/items`)
          .doc()
          .set({
            name: this.itemModel.name,
            pinned: this.itemModel.pinned,
            visible: true
          });
      }

      firestore.doc(`lists/${this.$route.params.id}/items/${this.itemModel.id}`).delete();

      this.itemModel.name = '';
      this.itemModel.pinned = '';
      this.itemModel.lastBought = '';
      this.itemModel.id = '';
      this.dialogModel.loading = false;
      this.dialogModel.moveItem = false;
    },
    goBack: function() {
      window.history.back();
    }
  },
  watch: {
    items: function(val) {
      if (val != [] && val != undefined && val != '') {
        this.dialogModel.loading = false;
      }

      this.listData.numOfCheckedItems = 0;

      val.forEach(
        function(item) {
          if (item.checked && item.visible) {
            this.listData.numOfCheckedItems++;

            if (item.lastBought) {
              console.log('islb');
              if (item.pinned) {
                // 3 days or more, hide

                const itemBoughtDate = this.$moment(item.lastBought);
                const currentDate = this.$moment(new Date());

                if (currentDate.diff(itemBoughtDate, 'days') >= 5) {
                  firestore.doc(`lists/${this.$route.params.id}/items/${item.id}`).update({
                    checked: false
                  });
                }
              } else {
                // 1 day or more, hide
                const itemBoughtDate = this.$moment(item.lastBought);
                const currentDate = this.$moment(new Date());

                if (currentDate.diff(itemBoughtDate, 'days') >= 1) {
                  firestore.doc(`lists/${this.$route.params.id}/items/${item.id}`).update({
                    visible: false
                  });
                }
              }
            } else {
              // Hide if legacy item
              if (item.pinned) {
                firestore.doc(`lists/${this.$route.params.id}/items/${item.id}`).update({
                  checked: false
                });
              } else {
                firestore.doc(`lists/${this.$route.params.id}/items/${item.id}`).update({
                  visible: false
                });
              }
            }
          }
        }.bind(this)
      );
    }
  }
};
</script>

<style scoped>
.strikethrough {
  text-decoration: line-through;
}

.listTitle {
  text-align: center;
  width: 100%;
}

.backButton {
  position: absolute;
  left: 16px;
  top: 21px;
  display: block;
  margin: 0;
  padding: 0;
}
</style>
